<template>
  <div class="my_issue_bus" >
    <div class="list_wrap">
      <List v-model="loading" :finished="finished" @load="loadMore" finished-text="It's the end~"> 
        <div class="item" v-for="(item,index) in list" :key="index" @click="goSupply(item)">
          <div class="item_top">
            <span v-if="item.type">#{{item.type}}#</span>{{item.productName}}
          </div>
          <div class="item_con van-multi-ellipsis--l2" v-html="item.content"></div>
          <div class="item_img" v-if="item.imgUrls">
            <img  v-for="(imgurl,ind) in item.imgUrls" :key="ind" :src="imgurl" v-load="'oPic'" >
          </div>
          <div class="item_img video" v-else-if="item.videos">
            <img  v-for="(video,ind) in item.videos" :key="ind" :src="video.cover"  >
            <div class="play_mask">
              <i class="iconfont icon-zhibo"></i>
            </div>
          </div>
          <div class="item_bottom">
            <div class="state_ok" v-if="item.auditState=='PASS'">
              <div class="item_count">
                 <i class="iconfont icon-guankan2"></i>
                <span>{{wCount(item.viewCount)}} </span>
                  <i class="iconfont icon-xunpan"></i>
                <span>{{wCount(item.commentCount)}} </span>
              </div>
              <p>{{item.createAt}}</p>
            </div>
            <div class="item_state" v-else>
              <div class="state0" :class="item.auditState=='NoPass'?'state-1':''">{{item.auditState=='NoPass'?'Audit failure':'Under review'}}</div>
              <div class="state_no" v-if="item.auditState=='NoPass'">
                <span @click.stop="delStateNoSupply(item.id)">delete</span>
                <div @click.stop="reEdit(item.id)">Re edit</div>
              </div>
            </div>
          </div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {    
  name: "my-issue-bus",
  data() {
    return {
      loading: false,   //联系我的加载状态
      finished: false,  //联系我的是否完成状态
      list: [],         //联系我的列表
      pageIndex: 0,
      pageSize:20,
      querySupplyDemand:{},
    };
  },
  components: { List },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId:"getExhibitionId"
    }),
  },
  created() {
  },
  methods: {
    ...mapActions({
      delSupply:'my/delSupply',
      LinkHotSupply:'linkTo/LinkHotSupply',
      LinkToSupply:'linkTo/LinkToSupply'
    }),
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    getList(){
      let query=gql`
      query querySupplyDemand($query:QueryInput!){
        querySupplyDemand(query:$query){
          hasNextPage
          indexFrom
          pageIndex
          pageSize
          items{
            auditState
            commentCount
            exhibitionId
            content 
            productName
            createAt
            id
            userCount
            memberId
            viewCount
            imgUrls
            videos
            type
          }
        }
      }`
      let where={
        "Equal":{
          "n":"memberId",
          "v":this.userInfo.inMember.memberId
        },
        "EqualB":{
          "n":"exhibitionId",
          "v":this.exhibitionId
        }
      }
      let order=[
        {
          "N":"createAt",
          "v":0
        }
      ]
      let opt={
        page:this.pageIndex,
        size:this.pageSize,
        where:JSON.stringify(where),
        order:JSON.stringify(order)
      }
      this.$apollo.addSmartQuery("querySupplyDemand",{ 
        query:query,
        variables:{
         query:opt
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          let res=JSON.parse(JSON.stringify(data.data.querySupplyDemand));
          // let res=data.data.queryProduct;
          console.log('发布供需',res);
          if(res.items.length){
            res.items.forEach(e => {
              e.type=e.type.indexOf('Supply')!=-1?'Supply':'Purchase'
              e.createAt=moment(e.createAt).format('YYYY/MM/DD HH:mm:ss');
              if(e.imgUrls){
                e.imgUrls= e.imgUrls.split(';');
              }
              if(e.videos){
                e.videos=JSON.parse(e.videos)
              }
              if(e.content){
                e.content=e.content.split("\n").join("<br>");
              }
            });
          }
          if(this.pageIndex==1){
            this.list=res.items
          }else{
            this.list=[...new Set([...this.list,...res.items])];
          }
          this.loading=false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.loading=false;
          this.finished = true;
          console.log('err',err)
        }
      })
      // setTimeout(()=>{
      //   this.list=[...this.list,...this.list];
      //   this.loading=false;
      //   if(this.list.length>20){
      //     this.finished=true
      //   }
      // },1000)
    },
    loadMore(){
      if(this.finished) return;
      this.pageIndex+=1;
      this.getList();
    },
    //删除供需
    async delStateNoSupply(id){
      let res=await this.delSupply(id);
      console.log(res);
      if(res.result){
        this.list=this.list.filter(item => item.id!=id);
        this.$toast.success("Deletion succeeded");
      }else{
        this.$toast.fail('Deletion failed')
      }
    },
    //重新编辑
    reEdit(id){
      this.LinkHotSupply(id);
    },
    //跳转到供需详情
    goSupply(item){
      if(item.auditState=='PASS'){
        this.LinkToSupply(item.id)
      }
      
    }
  }
};
</script>

<style scoped lang="scss">
//展品列表
.my_issue_bus{
  
  .list_wrap{
    .item{
      background-color: #fff;
      margin-bottom: 0.3rem;
      box-shadow: 0 0  0.1rem 0
      rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      padding:0.2rem;
      margin-bottom: 0.3rem;
      &:last-child{
        margin-bottom: 0;
      }
      .item_top{
        font-size: 0.26rem;
        // font-weight: bold;
        color: #333;
        line-height:0.4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        span{
          color:#1890ff;
          font-size: 0.26rem;
          margin-right: 0.05rem;
        }
      }
      .item_img{
        display: flex;
        margin-top: 0.2rem;
        &.video{
          position: relative;
          width: 1.1rem;
          height: 1.1rem;
          img{
            margin-right: 0;
          }
          .play_mask{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba($color: #000, $alpha: 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont{
              font-size: 0.64rem;
              color: #fff;
            }
          }
        }
        img{
          width: 1.1rem;
          height: 1.1rem;
          margin-right: 0.1rem;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      .item_bottom{
        *{
          font-size: 0.22rem;
        }
        margin-top: 0.3rem;
        .state_ok{
          display: flex;
          justify-content: space-between;
          color: #666;
          .item_count{
            span{
              margin-right:0.2rem;
              &:last-child{
                margin-right: 0;
              }
            }
           
          }
        }
        .item_state{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .state0{
            color: #ff9752;
            &.state-1{
              color:#ff563a;
            }
          }
          .state_no{
            display: flex;
            align-items: center;
            span{
              color:#ff563a;
              margin-right: 0.3rem;
            }
            div{
              padding: 0.05rem 0.2rem;
              border-radius: 0.05rem;
              background: #ff954f;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
